import React from 'react';
import { Pressable } from 'react-native';
import {
    View,
    StyleSheet,
    StyleProp,
    ViewStyle,
    Text,
} from 'react-native';
import { User } from "../../../../imsdk/db/t_user";
import { LeftView } from "../CListItem";
import { color_333333, color_main, white } from "../../../assets/style/colors";
import { getAvatarByItem, getDisplayName } from "../../../utils/utils";

export const userAvatarSize = 50;
export const ChatDetailUser = (props: {
    user: User;
    style?: StyleProp<ViewStyle>;
    action?: (user: User) => void;
}) => {
    const name = getDisplayName(props.user)

    return (
        <Pressable
            style={[styles.viewBox, props.style]}
            onPress={() => props.action?.(props.user)}>
            <View>
                <LeftView
                    left={getAvatarByItem(props.user as any) ?? []}
                    size={userAvatarSize}
                />
            </View>
            <Text numberOfLines={1} style={styles.name}>{name}</Text>
        </Pressable>
    );
};

const styles = StyleSheet.create({
    viewBox: {
        width: userAvatarSize,
    },
    avatar: {
        borderRadius: 4,
        backgroundColor: color_main,
        overflow: 'hidden',
    },
    name: {
        marginTop: 8,
        fontSize: 12,
        color: color_333333,
        textAlign: 'center',
    },
    avatarName: {
        color: white,
        fontSize: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
